module.exports = __webpack_public_path__ + "img/4.1c08ed5e.png";